export default __webpack_public_path__ + "static/media/berlin_dark.be088800.png";